export const nightModePages = [
    '/user/loyalty-rewards'
]


export const passwordlessNightModeScreen = [
    '/login',
    '/create-account',
    '/welcome',
    '/checkout/loyalty-rewards/([^/]+)',
]

export const dayModePages = [
    '/insomniarewards'
]


export const canonicalPages = [
    '/menu',
    '/store',
    '/products',
    '/shipping',
    '/findaninsomnia',
    '/insomniarewards',
    '/news',
]